import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SOURCES } from 'client/utils/image-helpers';
import { Image } from 'site-modules/shared/components/image/image';
import { Link } from 'site-modules/shared/components/link/link';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';
import { RenderWhenViewable } from 'site-modules/shared/components/render-when-viewable/render-when-viewable';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

import './most-popular-card.scss';

function renderOtherSubmodelInfo(submodelEntry) {
  return [1, 2, 3, 4].map(counter => (
    <p key={counter} className="mb-0_5">
      <Link className="underline" to={submodelEntry.contentMetadata[`link-url-${counter}`]}>
        {submodelEntry.contentMetadata[`title-${counter}`]}
      </Link>
    </p>
  ));
}

export function MostPopularCard({ className = null, popularSubmodel, isLazyImage = false }) {
  const { childEntries } = popularSubmodel;
  const topSubmodel = childEntries[0];
  const otherSubmodelsSection = childEntries[1];
  const topSubmodelImageSrc = topSubmodel.contentMetadata['media-image'];
  const topSubmodelTitle = topSubmodel.contentMetadata.title;
  const topSubmodelUrl = topSubmodel.contentMetadata['link-url'];
  const rel = topSubmodel.contentMetadata.rel;
  const footerContent = childEntries[2].contentMetadata;
  const footerContentTitle = footerContent['shop-text'];
  const footerContentUrl = footerContent['shop-url'];

  return (
    <div className={classNames('most-popular-card mb-1_5', className)}>
      <div className="most-popular-card-image">
        <AspectRatioContainer aspectRatio="3:2">
          <RenderWhenViewable>
            <Image
              imageId={topSubmodelImageSrc}
              alt={topSubmodelTitle}
              source={SOURCES.MEDIA}
              width={300}
              lazy={isLazyImage}
            />
          </RenderWhenViewable>
        </AspectRatioContainer>
      </div>
      <p className="mt-1 heading-5 mb-0_5">{topSubmodel.title}</p>
      <p>
        <Link className="underline" to={topSubmodelUrl} {...(rel ? { rel } : {})}>
          {topSubmodelTitle}
        </Link>
      </p>
      <p className="mt-1 heading-5 mb-0_5">{otherSubmodelsSection.title}</p>
      {renderOtherSubmodelInfo(otherSubmodelsSection)}
      <ArrowLink to={footerContentUrl} className="mt-1">
        {footerContentTitle}
      </ArrowLink>
    </div>
  );
}

MostPopularCard.propTypes = {
  popularSubmodel: PropTypes.shape({}).isRequired,
  className: PropTypes.string,
  isLazyImage: PropTypes.bool,
};
